module.exports = __webpack_public_path__ + "static/img/customer4.2abb4951.png";